import { Button, Modal } from "antd";
import { useContext } from "react";
import SettingContext from "../../core/context/SettingContext";
import {
  Magnifier,
  MOUSE_ACTIVATION,
  TOUCH_ACTIVATION,
} from "react-image-magnifiers";

const ProductDetailModal = () => {
  const {mProductShow, setMProductShow, mProductShowDetail, mProductIndex, setMProductIndex} = useContext(SettingContext);
  return (
    <Modal
      className="w-full productDetailInfoModal"
      width="100%"
      height="100vh"
      centered
      open={mProductShow}
      footer={false}
      closable={false}
    >
      <div className="flex flex-col justify-between h-full">
        <div>
          <Button onClick={() => setMProductShow(false)}>Back</Button>
        </div>
        <div className="overflow-auto">
          <Magnifier
            className="productMagnifier"
            imageSrc={mProductShowDetail?.imageURLs?.length > 0 && mProductShowDetail?.imageURLs[mProductIndex] || ''}
            imageAlt="Example"
            largeImageSrc={mProductShowDetail?.imageURLs?.length > 0 && mProductShowDetail?.imageURLs[mProductIndex] || ''}
            mouseActivation={MOUSE_ACTIVATION.DOUBLE_CLICK}
            touchActivation={TOUCH_ACTIVATION.LONG_TOUCH}
          />
        </div>
        <div className="p-20 flex">
          {mProductShowDetail?.imageURLs?.map((e, i) => (
            <div
              className={"m-5 bg-white border-2 hover:cursor-pointer " + (mProductIndex === i && 'border-supernova')}
              key={i}
            >
              <img
                src={e}
                height="85px"
                width="85px"
                onClick={() => setMProductIndex(i)}
              />
            </div>
          ))}
        </div>
      </div>
    </Modal>
  )
}
export default ProductDetailModal;